import { MantineColor } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import * as Unicons from '@iconscout/react-unicons';

interface NotificationProps {
  type: 'success' | 'info' | 'warning' | 'error';
  title?: string;
  message?: string;
  autoClose?: number;
  withCloseButton?: boolean;
  loading?: boolean;
  color?: MantineColor;
  icon?: React.ReactNode;
}

export const showNotification = ({
  type,
  message,
  title,
  autoClose,
  withCloseButton = false,
  color,
  icon,
  loading = false
}: NotificationProps) => {
  switch (type) {
    case 'success':
      return notifications.show({
        title: title || 'Success Insert Data',
        message: message || 'Data will be show in table.',
        autoClose: autoClose || 2000,
        withCloseButton: withCloseButton,
        color: color || 'green',
        loading: loading,
        icon
      });
    case 'error':
      return notifications.show({
        title: title || 'Request Failed',
        message: message || 'Please try again later.',
        autoClose: autoClose || 2000,
        withCloseButton: withCloseButton,
        color: color || 'red',
        loading: loading,
        icon
      });
    case 'warning':
      return notifications.show({
        title: title || 'Something Wrong',
        message: message || 'Please try again later.',
        autoClose: autoClose || 2000,
        withCloseButton: withCloseButton,
        color: color || 'yellow',
        loading: loading,
        icon
      });
    case 'info':
      return notifications.show({
        title: title || 'Information',
        message: message || 'Data will be show in table.',
        autoClose: autoClose || 2000,
        withCloseButton: withCloseButton,
        color: color || 'blue',
        loading: loading,
        icon
      });

    default:
      break;
  }
};
